import { render } from "./BaseInlineFormula.vue?vue&type=template&id=4aa558d6&scoped=true"
import script from "./BaseInlineFormula.vue?vue&type=script&lang=js"
export * from "./BaseInlineFormula.vue?vue&type=script&lang=js"

import "./BaseInlineFormula.vue?vue&type=style&index=0&id=4aa558d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa558d6"]])

export default __exports__